import React, { useState } from "react";
import emailjs from "emailjs-com";
import Swal from "sweetalert2";
import InputMask from "react-input-mask";

const initialState = {
  name: "",
  company: "",
  cnpj: "",
  email: "",
  tel: "",
  businessField: "",
  solutions: [],
  message: "",
};

const Msg = ({ closeModal }) => {
  const [formData, setFormData] = useState(initialState);
  const { name, company, cnpj, email, tel, businessField, solutions, message } =
    formData;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleMaskedInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => {
      if (checked) {
        return { ...prev, solutions: [...prev.solutions, value] };
      } else {
        return {
          ...prev,
          solutions: prev.solutions.filter((item) => item !== value),
        };
      }
    });
  };

  const clearState = () => setFormData(initialState);

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    const data = new FormData(form);
    data.set("solutions", solutions.join(", "));
    data.set("cnpj", cnpj);

    emailjs
      .sendForm(
        "service_0kpewf8",
        "template_81sfa52",
        form,
        "2nopBKgXfWdt76irZ"
      )
      .then(
        (result) => {
          console.log(result.text);
          if (closeModal) {
            closeModal();
          }
          Swal.fire({
            icon: "success",
            title: "Mensagem enviada!",
            text: "Obrigado pelo contato, responderemos em breve.",
            confirmButtonText: "Ok",
            background: "#fff",
            color: "#000",
            customClass: {
              confirmButton: "my-confirm-button",
              title: "my-title",
              popup: "my-popup",
            },
          });
          clearState();
        },
        (error) => {
          console.error(error.text);
          if (closeModal) {
            closeModal();
          }
          Swal.fire({
            icon: "error",
            title: "Erro ao enviar!",
            text: "Tente novamente mais tarde.",
            confirmButtonText: "Ok",
            background: "#fff",
            color: "#000",
            customClass: {
              confirmButton: "my-confirm-button",
              title: "my-title",
              popup: "my-popup",
            },
          });
        }
      );
  };

  return (
    <div className="msg-message-container">
      <div className="msg-content-wrapper">
        <div className="msg-form-wrapper">
          <h2>
            Preencha o formulário abaixo{" "}
            <strong>e fale conosco agora mesmo!</strong>
          </h2>
          <form name="sentMessage" onSubmit={handleSubmit} autoComplete="off">
            <div className="msg-form-row">
              <div className="msg-form-group msg-form-col">
                <label>Qual o seu nome?</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className="msg-form-control"
                  placeholder="Digite aqui..."
                  value={name}
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="msg-form-group msg-form-col">
                <label>Empresa</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  className="msg-form-control"
                  placeholder="Digite aqui..."
                  value={company}
                  required
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="msg-form-row">
              <div className="msg-form-group msg-form-col">
                <label>CNPJ</label>
                <InputMask
                  mask="99.999.999/9999-99"
                  id="cnpj"
                  name="cnpj"
                  className="msg-form-control"
                  placeholder="Digite aqui..."
                  value={cnpj}
                  required
                  onChange={handleMaskedInputChange}
                />
              </div>
              <div className="msg-form-group msg-form-col">
                <label>Telefone</label>
                <InputMask
                  mask="(99) 99999-9999"
                  id="telefone"
                  name="tel"
                  className="msg-form-control"
                  placeholder="Digite aqui..."
                  value={tel}
                  required
                  onChange={handleMaskedInputChange}
                />
              </div>
            </div>
            <div className="msg-form-row">
              <div className="msg-form-group msg-form-col">
                <label>E-mail</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="msg-form-control"
                  placeholder="Digite aqui..."
                  value={email}
                  required
                  onChange={handleChange}
                />
              </div>
              <div className="msg-form-group msg-form-col">
                <label>Ramo de atividade da Empresa</label>
                <input
                  type="text"
                  id="businessField"
                  name="businessField"
                  className="msg-form-control"
                  placeholder="Digite aqui..."
                  value={businessField}
                  required
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="msg-form-group msg-checkbox-group">
              <p>Soluções para sua Empresa</p>
              <div className="msg-checkbox-row">
                <div className="msg-checkbox-col">
                  {[
                    "Conta Digital",
                    "Fintech",
                    "Meios de Pagamentos",
                    "Api de Pix",
                  ].map((item) => (
                    <div key={item}>
                      <input
                        type="checkbox"
                        id={item}
                        name="solutions"
                        value={item}
                        checked={solutions.includes(item)}
                        onChange={handleCheckboxChange}
                      />
                      <label htmlFor={item}> {item}</label>
                    </div>
                  ))}
                </div>
                <div className="msg-checkbox-col">
                  {[
                    "Api de Bolepix",
                    "Link de Pagamentos",
                    "Gateway de Pagamento",
                    "Checkout",
                  ].map((item) => (
                    <div key={item}>
                      <input
                        type="checkbox"
                        id={item}
                        name="solutions"
                        value={item}
                        checked={solutions.includes(item)}
                        onChange={handleCheckboxChange}
                      />
                      <label htmlFor={item}> {item}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="msg-form-group">
              <label>Mensagem</label>
              <textarea
                name="message"
                id="message"
                className="msg-form-control"
                rows={4}
                placeholder="Digite aqui..."
                value={message}
                required
                onChange={handleChange}
              ></textarea>
            </div>
            <button type="submit" className="msg-btn">
              ENVIAR CONTATO
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Msg;
